<template>
  <div class="hidden-danger-content" @click="handleClick($event)">
    <vueSeamlessScroll
      v-if="protectList.length > 0"
      :data="protectList"
      :class-option="defaultOption"
      class="seamless-warp"
    >
      <div
        class="list"
        :class="item.state == 1 ? 'working' : 'knock-off'"
        v-for="(item, index) in protectList"
        :key="index"
        :data-item="JSON.stringify(item)"
      >
        <div class="li" :data-item="JSON.stringify(item)">
          {{ item.schoolName }}：{{ item.userName }}
          <span v-if="item.state == 1" :data-item="JSON.stringify(item)"
            >上岗中</span
          >
          <span v-if="item.state == 2" :data-item="JSON.stringify(item)"
            >已下岗</span
          >
        </div>
        <div class="sel" :data-item="JSON.stringify(item)">
          <div :data-item="JSON.stringify(item)">
            上岗时间：{{ $Common.dateFormatDateTwo(item.startTime) }}
          </div>
          <a href="javascript:;" :data-item="JSON.stringify(item)">查看详情</a>
        </div>
      </div>
    </vueSeamlessScroll>
    <div v-else class="no-data">暂无数据</div>
    <el-dialog
      class="hidden-detail-dlialog"
      :visible="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="padding: 0"
      :before-close="handleClose"
    >
      <div class="content">
        <div class="hidden-close" @click="handleClose">
          关闭
        </div>
        <div class="content-title">
          <img src="@/assets/img/hiddenDangerNow/school-logo.png" alt="" />
          <span>{{ resData.schoolName }}</span>
        </div>
        <div class="detail">
          <div class="img">
            <div class="list-img">
              <div class="name">上岗照片：</div>
              <div class="img-url">
                <el-image
                  v-if="resData.postPhoto"
                  style="width: 100px; height: 100px"
                  :src="$store.state.config.fileUrl + resData.postPhoto"
                  :preview-src-list="[
                    $store.state.config.fileUrl + resData.postPhoto
                  ]"
                  :fit="'contain'"
                >
                </el-image>
              </div>
              <div class="name" style="padding-top: 20px;">
                上岗地点：{{ resData.onPlace }}
              </div>
              <!-- <div class="name"></div> -->
            </div>
            <!-- <div class="list-img" v-if="resData.postPhoto">
              <div class="name">下岗照片：</div>
              <div class="img-url">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="
                    $store.state.config.fileUrl +
                      resData.postPhoto
                  "
                  :preview-src-list="[
                    $store.state.config.fileUrl +
                      resData.postPhoto
                  ]"
                  :fit="'contain'"
                >
                </el-image>
              </div>
            </div> -->
          </div>
          <div class="icon-list">
            <!-- <img
              class="icon-line"
              src="@/assets/img/hiddenDangerNow/rect-line.png"
              alt=""
            />
            <img
              class="list-li list-li-1"
              src="@/assets/img/hiddenDangerNow/report-icon.png"
              alt="上报"
            />
            <img
              class="list-li list-li-2"
              src="@/assets/img/hiddenDangerNow/time-icon.png"
              alt="上报时间"
            />
            <img
              class="list-li list-li-3"
              src="@/assets/img/hiddenDangerNow/description-icon.png"
              alt="描述"
            />
            <img
              class="list-li list-li-4"
              src="@/assets/img/hiddenDangerNow/status-icon.png"
              alt="状态"
            />
            <img
              class="list-li list-li-5"
              src="@/assets/img/hiddenDangerNow/label-icon.png"
              alt="类别"
            /> -->
          </div>
          <div class="detail-content">
            <div class="detail-label">
              <div class="label-1">护岗人：</div>
              <div class="label-2">上岗时间：</div>
              <div class="label-4">状态：</div>
              <div class="label-4">身份：</div>
              <div class="label-4">下岗时间：</div>
              <div class="label-5">下岗地点：</div>
            </div>
            <div class="tip">
              <div class="tip-1">
                {{ resData.userName }}
              </div>
              <div class="tip-2">
                {{ $Common.dateFormatDateTwo(resData.startTime) }}
              </div>
              <div class="tip-4">
                <span v-if="resData.state == 1">上岗中</span>
                <span v-if="resData.state == 2">已下岗</span>
              </div>
              <div class="tip-4">
                <span v-if="resData.isPs == 0">教师</span>
                <span v-if="resData.isPs == 1">民警</span>
                <span v-if="resData.isPs == 2">家长</span>
              </div>
              <div class="tip-4">
                <span v-if="resData.state == 1">上岗中</span>
                <span v-if="resData.state == 2">{{
                  $Common.dateFormatDateTwo(resData.endTime)
                }}</span>
              </div>
              <div class="tip-5">
                <span v-if="resData.state == 1">上岗中</span>
                <span v-if="resData.state == 2">{{ resData.downPlace }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "hiddenDangerNow",
  components: {
    vueSeamlessScroll
  },
  props: {
    protectList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      resData: {
        schoolName: " ",
        postPhoto: "",
        onPlace: "",
        userName: "",
        startTime: "",
        state: "",
        isPs: "",
        endTime: "",
        downPlace: ""
      },
      dialogVisible: false,
      listInfo: []
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() =>{
      console.log(this.protectList,'this.protectListprotectList')
    })
  },
  computed: {
    defaultOption() {
      return {
        step: 0.5, //步长 越大滚动速度越快
        limitMoveNum: 3, //启动无缝滚动最小数据量 this.dataList.length
        hoverStop: true, //是否启用鼠标hover控制
        direction: 1, //1 往上 0 往下
        openWatch: true, //开启data实时监听
        singleHeight: 0, //单条数据高度有值hoverStop关闭
        waitTime: 1000 //单步停止等待时间
      };
    }
  },
  watch: {
    protectList: function(newVal) {
      // console.log(newVal);
      if (newVal) {
        this.listInfo = newVal;
      } else {
        this.listInfo = [];
      }
    }
  },
  methods: {
    sel(item) {
      this.resData = item;
      this.dialogVisible = true;
    },
    clearData() {
      this.resData = {
        schoolName: "",
        postPhoto: "",
        onPlace: "",
        userName: "",
        startTime: "",
        state: "",
        isPs: "",
        endTime: "",
        downPlace: ""
      };
    },
    handleClose() {
      this.clearData();
      this.dialogVisible = false;
    },
    async getHazardDetails(id) {
      let req = {
        id: id
      };
      let res = await this.$Http.hazardDetails(req);
      if (res.code == 200) {
        res.data.addTime = this.$Common.dateFormatDateTwo(res.data.addTime);
        this.resData = res.data;
        this.dialogVisible = true;
        console.log(res.data);
      } else if (res.code == 101) {
      } else {
      }
    },
    handleClick(e) {
      // console.log(e);
      // console.log(e.target.getAttribute("data-item"));
      let item = e.target.getAttribute("data-item");
      if (item) {
        this.resData = JSON.parse(item);
        // console.log(this.resData)
        this.dialogVisible = true;
      }
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.hidden-danger-content {
  padding-top: 10px;
  width: 89.74%;
  height: 244px;
  overflow-y: hidden;
  margin: 0 auto;

  .list {
    width: 100%;
    text-align: left;
    margin-bottom: 16px;
    &.working {
      .li {
        background: url("~@/assets/img/eduBigData/list-bg-2.png") center center
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &.knock-off {
      .li {
        background: url("~@/assets/img/eduBigData/list-bg-3.png") center center
          no-repeat;
        background-size: 100% 100%;
      }
    }
    // &:nth-child(3n-2) {
    //   .li {
    //     background: url("~@/assets/img/eduBigData/list-bg-1.png") center center
    //       no-repeat;
    //     background-size: 100% 100%;
    //   }
    // }
    // &:nth-child(3n-1) {
    //   .li {
    //     background: url("~@/assets/img/eduBigData/list-bg-2.png") center center
    //       no-repeat;
    //     background-size: 100% 100%;
    //   }
    // }
    // &:nth-child(3n) {
    //   .li {
    //     background: url("~@/assets/img/eduBigData/list-bg-3.png") center center
    //       no-repeat;
    //     background-size: 100% 100%;
    //   }
    // }
    .li {
      width: 100%;
      padding: 6px 16px;
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #c9cbff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
      cursor: pointer;
    }
    .sel {
      display: flex;
      justify-content: space-between;
      line-height: 1;
      padding: 0 16px;
      margin-top: 8px;
      div {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(239, 250, 255, 0.6);
        line-height: 12px;
      }
      a {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(239, 250, 255, 0.8);
        line-height: 12px;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
  .no-data {
    width: 100%;
    height: 244px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
  }
}

.hidden-danger-content {
  /deep/ .el-dialog {
    width: 882px;
    height: 550px;
    background: transparent;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      height: 100%;
      padding: 0;
    }
  }
}

.content {
  padding-top: 12px;
  width: 100%;
  height: 100%;
  // 已修改
  background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png")
    center center no-repeat;
  background-size: 100% 100%;
  position: relative;
  .hidden-close {
    width: 56px;
    height: 24px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #d7deff;
    line-height: 25px;
    text-align: center;
    letter-spacing: 1px;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .content-title {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 64px;
      height: 64px;
    }
    span {
      margin-left: 16px;
      font-size: 24px;
      color: #ffff00;
    }
  }
  .detail {
    display: flex;
    justify-content: center;
  }
  .img {
    margin-top: 14px;
    width: 294px;
    height: 390px;
    padding: 24px 40px 40px 16px;
    box-shadow: 0px 0px 29px 0px rgba(153, 178, 255, 0.5) inset;
    border-radius: 1px;
    .list-img {
      text-align: left;
      margin-bottom: 22px;
      .name {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 25px;
        letter-spacing: 1px;
      }
      .img-url {
        margin-top: 14px;
        padding-left: 22px;
        .el-image {
          width: 216px;
          height: 118px;
        }
      }
    }
  }
  .icon-list {
    width: 40px;
    margin-left: 35px;
    margin-right: 36px;
    position: relative;
    top: 12px;
    .icon-line {
      height: 400px;
      position: absolute;
      top: 0;
      left: 17px;
      z-index: 2;
    }
    .list-li {
      display: block;
      width: 38px;
      height: 40px;
      position: relative;
      z-index: 3;
      &.list-li-1 {
        margin-bottom: 32px;
      }
      &.list-li-2 {
        margin-bottom: 32px;
      }
      &.list-li-3 {
        margin-bottom: 84px;
      }
      &.list-li-4 {
        margin-bottom: 32px;
      }
      &.list-li-5 {
        margin-bottom: 32px;
      }
    }
  }
  .detail-content {
    padding-top: 18px;
    display: flex;
    justify-content: flex-start;
    .detail-label {
      width: 103px;
      text-align: right;
      div {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        letter-spacing: 1px;
        &.label-1 {
          margin-bottom: 46px;
        }
        &.label-2 {
          margin-bottom: 48px;
        }
        &.label-3 {
          margin-bottom: 100px;
        }
        &.label-4 {
          margin-bottom: 48px;
        }
        &.label-6 {
          opacity: 0;
        }
      }
    }
    .tip {
      width: 250px;
      text-align: left;
      div {
        padding-bottom: 8px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #d7deff;
        line-height: 25px;
        letter-spacing: 1px;
        border-bottom: 1px solid rgba(120, 125, 233, 0.6);
        &.tip-1 {
          margin-bottom: 38px;
        }
        &.tip-2 {
          margin-bottom: 38px;
        }
        &.tip-3 {
          height: 93px;
          margin-bottom: 32px;
          overflow-y: scroll;
        }
        &.tip-4 {
          margin-bottom: 40px;
        }
        &.tip-5 {
          margin-bottom: 12px;
        }
        &.tip-6 {
          border-bottom: none;
          padding: 8px 13px;
          // box-shadow: 0px 0px 25px 0px rgba(8, 16, 58, 0.5) inset;
          background: url("~@/assets/img/hiddenDangerNow/big-data-handle-time-bg.png")
            center center no-repeat;
          background-size: 100% 100%;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffa9;
          line-height: 25px;
          letter-spacing: 1px;
          span {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #d7deff;
            line-height: 25px;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
}
</style>
